import { useCallback, useState } from "react";
import DialogCriacaoEditPerfil from "./DialogCriacaoEditPerfil";
import IRequest from "../../../types/IRequest";
import { IDataPerfis } from "../../../types/api/configuracoes/pesquisa-perfis";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";

export default function Perfis() {

    const [openModal, setOpenModal] = useState<TOpenModalPerfil>(null)
    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: IDataPerfis | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
    }, [])
    //

    return (
        <>
            <SessaoConfiguracao<IDataPerfis>
                titulo="Perfis"
                endpoints={{
                    listar: "pesquisar-perfis",
                    deletar: "excluir-perfil",
                }}
                colunas={colunas}
                queryKey="pesquisar-perfis"
                onEditar={(perfil) => {
                    handleModalAction("open", perfil.id, perfil)
                }}
                onAdicionar={() => {
                    handleModalAction("open", true, null)
                }}
                mensagemSucessoDeletar="Exclusão do perfil realizada com sucesso!"
                mensagemErroDeletar="Erro ao excluir perfil!"
                mensagemSemDados="Nenhum perfil encontrado."
            />

            {
                Boolean(openModal) &&
                <DialogCriacaoEditPerfil
                    defaultValue={openModal?.defaultValue ? openModal : null}
                    open={Boolean(openModal)}
                    handleClose={() => handleModalAction("close")}
                />
            }

        </>
    )
}

export interface IPerfis {
    reqPerfis: IRequest<IDataPerfis>,
    dataPerfis: IDataPerfis[]
}

export type TOpenModalPerfil = {
    open: number | boolean | null;
    defaultValue: IDataPerfis | null;
} | null

const colunas: ConfiguracaoColunas<IDataPerfis>[] = [
    {
        campo: "nome",
        titulo: "Nome",
    },
];